import { render, staticRenderFns } from "./table-tool.vue?vue&type=template&id=be721266&scoped=true&"
import script from "./table-tool.vue?vue&type=script&lang=js&"
export * from "./table-tool.vue?vue&type=script&lang=js&"
import style0 from "./table-tool.vue?vue&type=style&index=0&id=be721266&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be721266",
  null
  
)

export default component.exports